import i18n from '@/i18n'

const datePickerShortcuts = () => [
  {
    text: i18n.t('global.time.today'),
    onClick: () => {
      const startDate = new Date()
      const endDate = new Date()

      startDate.setHours(0, 0, 0)
      endDate.setHours(23, 59, 59)

      return [startDate, endDate]
    },
  },
  {
    text: i18n.t('global.time.yesterday'),
    onClick: () => {
      const startDate = new Date()
      const endDate = new Date()

      startDate.setDate(startDate.getDate() - 1)
      startDate.setHours(0, 0, 0)

      endDate.setDate(endDate.getDate() - 1)
      endDate.setHours(23, 59, 59)

      return [startDate, endDate]
    },
  },
  {
    text: i18n.t('global.time.last7Days'),
    onClick: () => {
      const startDate = new Date()
      const endDate = new Date()

      startDate.setDate(startDate.getDate() - 7)
      startDate.setHours(0, 0, 0)
      endDate.setHours(23, 59, 59)

      return [startDate, endDate]
    },
  },
  {
    text: i18n.t('global.time.last30Days'),
    onClick: () => {
      const startDate = new Date()
      const endDate = new Date()

      startDate.setDate(startDate.getDate() - 30)
      startDate.setHours(0, 0, 0)
      endDate.setHours(23, 59, 59)

      return [startDate, endDate]
    },
  },
  {
    text: i18n.t('global.time.thisMonth'),
    onClick: () => {
      const startDate = new Date()
      const endDate = new Date()

      startDate.setDate(1)
      startDate.setHours(0, 0, 0)
      endDate.setHours(23, 59, 59)

      return [startDate, endDate]
    },
  },
  {
    text: i18n.t('global.time.lastMonth'),
    onClick: () => {
      const startDate = new Date()
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * startDate.getDate())
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * (startDate.getDate() - 1))
      startDate.setHours(0, 0, 0)

      const endDate = new Date()
      endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * endDate.getDate())
      endDate.setHours(23, 59, 59)

      return [startDate, endDate]
    },
  },
].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))

export default datePickerShortcuts
